/** GA4 (gtag) helpers — base script lives in index.html. */

export const GA_MEASUREMENT_ID = "G-LRZYZ8QLM6";

/**
 * Fire a GA4 event. Safe if gtag is missing.
 * Pass `event_callback` / `event_timeout` in params to wait before navigations.
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackGaEvent(eventName, params) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  if (params && Object.keys(params).length > 0) {
    window.gtag("event", eventName, params);
    return;
  }
  window.gtag("event", eventName);
}
